import { Component, Input } from '@angular/core';

/**
 * __Usage__:
 * ```html
 * <ls-boolean [state]="true|false"></ls-boolean>
 * ```
 */
@Component({
  selector: 'ls-boolean',
  templateUrl: './boolean.component.html',
  styleUrls: ['./boolean.component.scss']
})
export class BooleanComponent {
  @Input()
  public state = false;
  public iconTrue = 'fa-check';
  public iconFalse = 'fa-times';

  public getStateIcon(): string {
    return this.state ? this.iconTrue : this.iconFalse;
  }
}
